import { gql } from '@apollo/client';
import userEventParticipationInfoCalendarViewFragment from './userEventParticipationInfoCalendarViewFragment';

const SAVE_OBSERVATION_ACTION = gql`
  mutation SaveObservationAction($assignmentData: EventObservationAssignmentActionInput!) {
    saveObservationAction(assignmentData: $assignmentData) {
      Id
      UserAssignmentPendingActions {
        ObservationAssignmentActionRequired
      }
      TargetUserEventParticipationInfo {
        ...UserEventParticipationInfoFields
      }
    }
  }

  ${userEventParticipationInfoCalendarViewFragment}
`;

export default SAVE_OBSERVATION_ACTION;
